import React from "react";
import {backgroundColor} from "../App/theme.js";
import {isMobile} from "../App/utils";


export const HTMLToIframe = (HTML, iframeRef, isFullscreen) => {
    const htmlBlob = new Blob([HTML], {type: 'text/html'});
    const htmlUrl = URL.createObjectURL(htmlBlob);
    const fullScreenStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 10000,
        border: 'none',
        backgroundColor: backgroundColor
    };

    return (
        <>
            <iframe
                ref={iframeRef}
                id="htmlContentIframe"
                src={htmlUrl}
                style={{
                    width: isMobile ? '300px' : '500px',
                    minHeight: '500px',
                    border: 'solid 1px',
                    ...(isFullscreen && fullScreenStyle)}}
                title="HTML Content"
                sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-downloads allow-popups"
            ></iframe>
        </>
    );
}